import crypto from 'crypto-js';

import { UserState } from '@/store/user/user.model';
import { Store } from 'vuex';
import { RootState } from './types';

// Use this promise-timeout to wait for GTM to be fully loaded before tracking events, on page-load
export const trackSleep = async (milliseconds: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, milliseconds));
enum Environments {
  integration = 'int',
  production = 'prod',
  development = 'dev',
}

const getPageParams = () => {
  const { hash } = window.location;
  // get page path without query params or hashes
  const pagePath = hash.split('#')[1]?.split('?')[0];
  const query = hash.split('?')[1] || '';

  return {
    pagePath,
    referrer: window.document.referrer,
    queryParams: query ? `?${query}` : '',
  };
};

export const trackEvent = (eventAction: string, eventArgs: { [key: string]: string | number }, store: Store<RootState>) => {
  const { queryParams, pagePath, referrer } = getPageParams();
  const user = store.state.users?.user;

  const event: { [key: string]: string | number } = {
    event: 'ga4_event',
    event_name: eventAction,
    event_category: 'business',
    event_action: eventAction,
    country: store.state.app.activeCountry,
    language: store.state.app.activeLanguage,
    legal_entity: user?.legalEntityId,
    environment: Environments[process.env.NODE_ENV!],
    page_location: window.location.href,
    page_title: window.document.title,
    page_path: pagePath,
    page_platform: 'web',
    ...eventArgs,
  };

  if (user?.uuid) {
    event.legal_entity = user.legalEntityId;
    event.user_id = crypto.SHA256(user.uuid).toString(crypto.enc.Hex);
  }

  if (queryParams) {
    event.page_query_parameter = queryParams;
  }

  if (referrer) {
    event.page_referrer = referrer;
  }

  window.dataLayer.push(event);
};

export const trackPageView = async (currentCountry?: string, currentLanguage?: string, currentUser?: UserState) => {
  await trackSleep(200);
  const { queryParams, pagePath, referrer } = getPageParams();
  const event: { [key: string]: string | number | undefined } = {
    event: 'pageview',
    country: currentCountry,
    language: currentLanguage,
    environment: Environments[process.env.NODE_ENV!],
    legal_entity: currentUser?.legalEntityId,
    page_location: window.location.href,
    page_title: window.document.title,
    page_path: pagePath,
    page_platform: 'web',
  };

  if (currentUser?.uuid) {
    event.user_id = crypto.SHA256(currentUser.uuid).toString(crypto.enc.Hex);
  }

  if (queryParams) {
    event.page_query_parameter = queryParams;
  }

  if (referrer) {
    event.page_referrer = referrer;
  }

  window.dataLayer.push(event);
};
